
import React, { useState, useEffect, useMemo } from 'react';
import Chart from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import * as Actions from './store/actions';

function cal(data) {
  let avg = [];

  data.forEach(item => {
    let sum = 0;
    let cpus = 0;
    item.forEach(item => {
      sum += item.loadAvg;
      cpus += item.cpus;
    });
    avg.push(((sum / cpus)).toFixed(3));
  });

  //Fill the array to 30 elements to shift the chart to the right
  while (avg.length < 30) {
    avg.unshift(null);
  }

  const chartData = {
    labels: Array.from({ length: 30 }, (_, i) => 30 - i + " min"),
    datasets: [
      {
        data: Array.from(avg, (a) => a),
        borderColor: 'rgba(3, 155, 229, 1)',
        backgroundColor: 'rgba(100, 182, 241, 0.33)',
        tension: 0.2,
        fill: true,
      }]
  }

  return chartData;
}

const LineChart = (props) => {
  const { CpuAvgData } = props;
  const selectedCluster = useSelector(({ dashboard }) => dashboard.selectedCluster.data);
  const [data, setData] = useState(cal(CpuAvgData));

  useEffect(() => {
    let filteredData = CpuAvgData;
    if (selectedCluster !== 'All') {
      filteredData = CpuAvgData.map((item) => {
        return item.filter((subItem) => subItem.cluster_id === selectedCluster);
      });
    }
    setData(cal(filteredData));
  }, [CpuAvgData, selectedCluster]);

  return (
    <Chart
      height={100}
      type={'line'}
      data={data}
      options={{
        legend: {
          display: false,
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              //  position: 'right',
              ticks: {
                stepSize: 0.2,
                suggestedMin: 0,
                suggestedMax: 1,
                fontColor: 'white',
              },
              gridLines: {
                display: true,
              },

            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: 'white',
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
      }}
    />
  );
}

const SelectComponent = () => {
  const allCluster = useSelector(({ dashboard }) => dashboard.allCluster.data);
  const clusters = useMemo(() => [...allCluster], [allCluster]);

  const selectedCluster = useSelector(({ dashboard }) => dashboard.selectedCluster.data);

  const dispatch = useDispatch();
  const handleChange = (e) => {
    dispatch(Actions.getSelectedCluster(e.target.value));
  }

  return (
    <div>
      <select id="options" value={selectedCluster} onChange={handleChange}>
        <option value="All"> All </option>
        {clusters.map((cluster) => (
          cluster.state === 'available' && (
            <option key={cluster.id} value={cluster.id}>
              {cluster.name}
            </option>
          )
        ))}
      </select>
    </div>
  );
};

export { LineChart, SelectComponent };